import React from "react";
// Creating the context object and passing the default values.
const GlobalContext = React.createContext({ status: null, login: () => { }, localstorage: {} });
export default GlobalContext;